import * as z from "zod";

export const ShopperAgentReturnsConfigSchema = z.object({
  instantExchangesEnabled: z.boolean(),
});

export type ShopperAgentReturnsConfig = z.infer<
  typeof ShopperAgentReturnsConfigSchema
>;
